(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeCalendar', PropriedadeCalendar);

  function PropriedadeCalendar() {
    return {
      restrict: 'E',
      controller: 'PropriedadeCalendarCtrl',
      controllerAs: 'calendar',
      templateUrl: 'views/propriedade/propriedade-calendar.html',
      scope: {
        disabled: '<',
        filters: '<',
        onChange: '&',
        sharedData: '<'
      },
      bindToController: true
    };
  }

}());
